import router from '@/router';
import { ID, LINKS } from '@/utils/links';

type data = {
  type?: ResourceType;
  id?: ID;
  alert_id?: string | number;
};

type RouteConfig = {
  base: (id: ID) => string;
  fallback: string;
};

const GLOBAL_FALLBACK = '/';

export enum ResourceType {
  CARE_REQUEST_ASSIGNATION = 'CARE_REQUEST_ASSIGNATION',
  CARE_REQUEST = 'CARE_REQUEST',
  MISSION = 'MISSION',
  MISSION_SLOT = 'MISSION_SLOT',
  MISSION_ASSIGNATION = 'MISSION_ASSIGNATION',
  MESSAGE = 'MESSAGE',
  INVOICE = 'INVOICE',
}

const routeConfigByType: Record<ResourceType, RouteConfig> = {
  MISSION: {
    base: (id: ID) => LINKS.MISSIONS.ID(id),
    fallback: LINKS.TABS.OFFERS,
  },
  MISSION_SLOT: {
    base: (id: ID) => LINKS.MISSIONS.ID(id),
    fallback: LINKS.TABS.OFFERS,
  },
  MISSION_ASSIGNATION: {
    base: (id: ID) => LINKS.MISSIONS.ASSIGNATION(id),
    fallback: LINKS.TABS.OFFERS,
  },
  CARE_REQUEST: {
    base: (id) => LINKS.APPOINTMENTS.ID(id),
    fallback: LINKS.TABS.OFFERS,
  },
  CARE_REQUEST_ASSIGNATION: {
    base: (id: ID) => LINKS.APPOINTMENTS.ASSIGNATION.BASE(id),
    fallback: LINKS.TABS.OFFERS,
  },
  INVOICE: {
    base: (id: ID) => `${LINKS.TABS.INVOICES_BASE}/${id}`,
    fallback: LINKS.TABS.INVOICES_BASE,
  },
  MESSAGE: {
    base: () => '/messages',
    fallback: '/messages',
  },
};

export function redirectNotificationOrAlertToRessource(data: data) {
  const { type, id, alert_id } = data ?? {};

  // Règle unique :
  // - type + id présents → navigation directe vers la ressource
  // - sinon → détail de l'alerte (si alert_id) ou fallback
  if (type && id !== null && id !== undefined && routeConfigByType[type]) {
    const target = routeConfigByType[type].base(id);
    router.push(target);
    return;
  }

  if (alert_id !== null && alert_id !== undefined) {
    const target = `${LINKS.NOTIFICATION}/${alert_id}`;
    router.push(target);
    return;
  }

  if (type && routeConfigByType[type]) {
    const { fallback } = routeConfigByType[type];
    router.push(fallback);
    return;
  }

  console.error('[NOTIF] ❌ données insuffisantes', data);
  router.push(GLOBAL_FALLBACK);
}
